import Weather from '../components/Weather';
import '../styles/exploration.scss'
import { FaMoon } from 'react-icons/fa';
import usePageTitle from '../hooks/usePageTitle';

function Exploration() {
  usePageTitle('Exploration | Dochano');

  return (
    <section id="Exploration">
      <div id="Intro">
          <h1>Exploration</h1>
      </div>
      <p>This page is devoted to a test arena along with interesting sites related to Web Engineering.</p>

      <div id="css-tricks">
        <h2>CSS Tricks</h2>
        <p className="indent">I keep up with some site styling topcis as in my University days as a computer lab tech I would challenge myself to make any design or picture into a working website. This area is deticated to some fun elements that can make a site stand out. Inspired by <a href="https://codepen.io/spark" target="_blank" rel="noopener noreferrer">CodePen Spark</a> and <a href="https://css-tricks.com/" target="_blank" rel="noopener noreferrer">CSS Tricks</a></p>
        <dl className="indent">
          <dt>Display Weather API within a sparkle bordered Ad to make it catch the users eye. Click the "Embrace: <FaMoon title="Dark Mode" />" to see a different view.</dt>
          <dd><Weather id="Weather" location="Denver" /></dd>
          <dt><a href="https://dev.to/ivordev/triggering-a-popover-with-pure-css-no-javascript-required-12eb" target="_blank" rel="noopener noreferrer">CSS Only Pop-up</a></dt>
          <dd>Uses input checkbox style trigger handling to open. Intersting but would be an odd for A11Y users.</dd>
          <dt><a href="https://dev.to/giftintech/how-to-make-a-simple-bounce-animation-with-just-html-and-css-2lae" target="_blank" rel="noopener noreferrer">CSS Bounce</a> <div class="bounce"></div></dt>
          <dd>Style used to move an element from side to side or up and down.</dd>
        </dl>
      </div>
      
      <div id="python-playground">
        <h2>Python Plyground</h2>
        <p className="indent">Be sure to checkout my public <a href="https://github.com/grjohnson1/Python_Arena" target="_blank" rel="noopener noreferrer">GitHub python_arena</a> to see some of the items I have been working on in my spare time. Originally dove into topics surrounding Machine Learning, Model Training, and AI. Now I am diving deeper into Python coding.</p>
        
        <h3>Python Standout Scripts</h3>

        <h4>mazeGenerator.py</h4>
        <p className="indent">This draws a maze using a grid layout. This gave me the idea to create a maze game for my website which you can see at <a href="/Maze">Maze</a>.</p>

        <h4>Dolittle.py</h4>
        <p className="indent">This is a manual learning script which will ask a question in attempt to identify the Animal you are thinking of. If it doesn't answer correctly it will ask for the Animal and a question that is unique to that Animal. It stores the questions and answers which it will use in the future question. This script will identify the best question to ask that will have the greatest chance at slimming the universe until it identifies the Animal. As this build over time this is a very time consumming process. But shows an option of learning over time rather than relying on a Data Lake to be used.</p>

        <h4>pdf_keyword_search.py</h4>
        <p className="indent">Ability to provide a list of words to be identified within a folder holding PDF files. It will search each PDF for the word or words and create a CSV file with the results of the word used and which PDF file (by name) has it. This one was personally created and not from the text book.</p>
        
        <h4><a href="https://github.com/grjohnson1/Python_Arena/tree/main/AI_InEasySteps/FlatworldGame" target="_blank" rel="noopener noreferrer">Flatworld Game</a></h4>
        <p className="indent">Visual game where the projects build off of each other. Best to see screenshots and read more from the <a href="https://github.com/grjohnson1/Python_Arena/tree/main/AI_InEasySteps/FlatworldGame" target="_blank" rel="noopener noreferrer">GitHub Repo Readme file</a> directly.</p>
      </div>
    </section>
  );
}

export default Exploration;